import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/home';

interface VideoCardProps {
  video: VideoItem;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`relative overflow-hidden rounded-lg mb-3 ${size === 'large' ? 'aspect-[16/9]' : 'aspect-[16/9]'}`}>
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
        />
        <div className="absolute bottom-2 right-2 bg-foreground-950/75 text-background-50 text-xs px-1.5 py-0.5 rounded">
          {video.duration}
        </div>
        <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/10 transition-colors duration-300"></div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className={`font-medium text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 leading-snug ${size === 'large' ? 'text-base' : 'text-sm'}`}>
        {video.title}
      </h3>
      <div className="flex items-center gap-3 mt-1.5">
        <div className="flex items-center gap-1.5">
          <img
            src={video.authorAvatar}
            alt={video.author}
            className="w-5 h-5 rounded-full object-cover"
          />
          <span className="text-xs text-foreground-500">{video.author}</span>
        </div>
        <span className="text-xs text-foreground-400">{video.views}次播放</span>
      </div>
    </Link>
  );
}